module.exports = __webpack_public_path__ + "assets/img/news (14).53a3aaa7.png";